module.exports = __webpack_public_path__ + "img/px.765c1d45.jpg";